import { render } from "./prompt-preview.vue?vue&type=template&id=521a9e54&lang=pug"
import script from "./prompt-preview.vue?vue&type=script&lang=js"
export * from "./prompt-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__